export default "__VITE_ASSET__4d735ec7__"